<template lang="pug">
v-app
    router-view
    dialog-bus
    snackbar-bus
    notifications(animation-type="velocity" width="300px")
</template>

<script>
import DialogBus from "@/components/global/DialogGlobal.vue"
import SnackbarBus from "@/components/global/SnackbarGlobal.vue"
import {VIEWPORTS} from "./util/const";

export default {
  name: 'App',
  components: {
    DialogBus,
    SnackbarBus
  },
  metaInfo: {
    meta: [
      { vmid: 'viewport-main', name: 'viewport', content: VIEWPORTS.DEFAULT }
    ]
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/index";
</style>
